// Copyright (c) 2022-2024. Sendanor <info@sendanor.fi>. All rights reserved.

import React from "react";
import { FacebookPixelUtils } from "../../../../../../../io/hyperify/core/facebook/FacebookPixelUtils";
import { map } from "../../../../../../../io/hyperify/core/functions/map";
import { Currency } from "../../../../../../../io/hyperify/core/types/Currency";
import { FACEBOOK_PIXEL_ID } from "../../../../../core/constants/ads";
import {
    VIRTUAL_SERVER_INDEX_VIEW_CLASS_NAME
} from "../../../../../core/constants/className";
import { ALL_VPS_EXTRA_PRODUCT_IDS, SendanorProductId } from "../../../../../core/types/SendanorProductId";
import { FacebookPixel } from "../../../common/facebookPixel/FacebookPixel";
import { VirtualServerExtraProductListView } from "./VirtualServerExtraProductListView";
import { VirtualServerExtraProductView } from "./VirtualServerExtraProductView";
import { VirtualServerFaqView } from "./VirtualServerFaqView";
import { VirtualServerFooterView } from "./VirtualServerFooterView";
import { VirtualServerIntroView } from "./VirtualServerIntroView";
import { VirtualServerProductView } from "./VirtualServerProductView";
import {
    VIRTUAL_SERVER_EXTRA_ROUTE,
} from "../../../../../core/constants/route";
import { TranslationFunction } from "../../../../../../../io/hyperify/core/types/TranslationFunction";
import "./VirtualServerIndexView.scss";

export interface VirtualServerIndexViewProps {
    readonly t: TranslationFunction;
    readonly className?: string;
}

export function VirtualServerIndexView ( props: VirtualServerIndexViewProps) {
    const t: TranslationFunction = props.t;
    return (
        <div className={VIRTUAL_SERVER_INDEX_VIEW_CLASS_NAME}>
            <FacebookPixel url={FacebookPixelUtils.getViewContentURL(FACEBOOK_PIXEL_ID, 0, Currency.EUR )} />
            <VirtualServerIntroView t={t} />
            <VirtualServerProductView t={t} />
            <VirtualServerFaqView t={t} />
            <VirtualServerExtraProductListView t={t} />
            {map(
                ALL_VPS_EXTRA_PRODUCT_IDS,
                (product: SendanorProductId, index: number) => {
                    return (
                        <VirtualServerExtraProductView
                            key={VIRTUAL_SERVER_EXTRA_ROUTE(product)}
                            t={t}
                            product={product}
                            odd={index%2 !== 0}
                        />
                    );
                }
            )}
            <VirtualServerFooterView t={t} />
        </div>
    );
}
